import adminApi from "../../../../api/adminApi";
import type { BackupMasterApplicationLogs } from "../../../../api/types/integrationsTypes";
import LogsWrapper from "../../../common/syncLogs/LogsWrapper";
import DataBackupLogsTable from "./DataBackupLogsTable";

const DataBackupLogsPage = () => {
  return (
    <LogsWrapper<BackupMasterApplicationLogs>
      fetchLogsFromApi={(params) => adminApi.getDataBackupLogs(params)}
      renderTable={(logItems) => <DataBackupLogsTable logItems={logItems} />}
    />
  );
};

export default DataBackupLogsPage;
